if (!customElements.get('jw-catalog-filter')) {
  customElements.define('jw-catalog-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      if (!form) return;
      const query = form.elements.q;
      const category = form.elements.category;
      const cards = [...this.querySelectorAll('[data-design]')];
      const counter = this.querySelector('[data-results-count]');
      const empty = this.querySelector('[data-no-results]');
      const normalize = text => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/ear\s*rings?/g, 'earrings').replace(/arm\s*cuffs?/g, 'arm cuffs').trim();
      const params = new URLSearchParams(location.search);
      query.value = (params.get('q') || '').slice(0, 120);
      if ([...category.options].some(option => option.value === params.get('category'))) category.value = params.get('category');
      const apply = (updateUrl = true) => {
        const words = normalize(query.value).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const match = (!category.value || card.dataset.category === category.value) && words.every(word => normalize(card.dataset.search).includes(word));
          card.hidden = !match;
          if (match) count++;
        });
        counter.textContent = this.dataset.countLabel.replace('[count]', count);
        empty.hidden = count !== 0;
        if (updateUrl) {
          const url = new URL(location.href);
          for (const [key, value] of [['q', query.value.trim()], ['category', category.value]]) {
            if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
          }
          history.replaceState(null, '', url);
        }
      };
      form.addEventListener('submit', event => {event.preventDefault(); apply();});
      query.addEventListener('input', () => apply());
      category.addEventListener('change', () => apply());
      form.addEventListener('reset', () => { query.value = ''; category.value = ''; apply(); });
      apply(false);
    }
  });
}
